let availablePlatform = {
  'Linux': true,
  'Mac68K': true,
  'MacPPC': true,
  'Macintosh': true,
  'MacIntel': true,
  'Win32': true,
  'Win64': true,
  // 'WinCE': false,
  'Windows': true,
  'iPhone': true,
  'iPad': true,
  'Android': true,
}
let platform = {
  name: '',
  isApple: false, // ios || macOS
  isWindows: false,
  isIOS: false, // iPhone || ipad
  isIPad: false,
  isIPhone: false,
  isMacOS: false,
  isLinux: false,
  isAndroid: false,
  check (window) {
    checkPlatform(window)
  }
}

function checkPlatform (window) {
  if (!window) return
  let p = window.navigator.platform
  if (!p) return
  let platformStr = 'Unknown'
  for (let key of Object.keys(availablePlatform)) {
    if (p.indexOf(key) !== -1) {
      platformStr = key
      break
    }
  }
  let s = platform
  s.name = platformStr
  if (availablePlatform[platformStr]) {
    switch (platformStr) {
      case 'Linux':
        s.isLinux = true
        break
      case 'Mac68K':
        s.isMacOS = true
        break
      case 'MacPPC':
        s.isMacOS = true
        break
      case 'Macintosh':
        s.isMacOS = true
        break
      case 'MacIntel':
        s.isMacOS = true
        break
      case 'Win32':
        s.isWindows = true
        break
      case 'Win64':
        s.isWindows = true
        break
      case 'Windows':
        s.isWindows = true
        break
      case 'iPhone':
        s.isIPhone = true
        break
      case 'iPad':
        s.isIPad = true
        break
      case 'Android':
        s.isAndroid = true
        break
    }
    s.isIOS = s.isIPad || s.isIPhone
    s.isApple = s.isIOS || s.isMacOS
  }
}

export {platform, checkPlatform}
